import { types } from 'mobx-state-tree';

const VideoResult = types.model('VideoResult', {
  videoId: types.string,
  videos: types.optional(types.array(types.string), []),
})

export default VideoResult;
